<div #container></div>

<!-- Floating circle when drawer is collapsed -->
@if (visible && collapsed) {
    <div class="summary-floating" (click)="expandSummary()">
        <div class="circle-content">
            <i class="pi pi-file-pdf"></i>
            <span class="export-count">{{ totalItems }}</span>
        </div>
        <div class="circle-tooltip">
            {{ totalItems }} PDF export{{ totalItems !== 1 ? 's' : '' }} in progress
        </div>
    </div>
}

<p-sidebar [visible]="visible && !collapsed"
           position="top"
           [modal]="false"
           [baseZIndex]="10000"
           [appendTo]="container"
           [showCloseIcon]="false"
           [closeOnEscape]="false"
           styleClass="summary-drawer">
    <ng-template pTemplate="header">
        <div class="summary-header">
            <div class="summary-header-content">PDF exporting summary</div>
            <div class="summary-header-actions">
                <div class="summary-collapse" (click)="hideSummary()">
                    <i class="pi pi-chevron-up collapse-icon"></i>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <pdf-export-summary [summaries]="summaries"></pdf-export-summary>
    </ng-template>
</p-sidebar>

